/**
 * This file let you add new layouts.
 */

const customLayoutConfig = {}

export default customLayoutConfig
